// Marmeto Product Card

class MarmetoProductCard extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId
    this.showsubs = this.dataset.showSub
    this.addEventListener('change', event => {
      if (event.target.name == "id") this.variantChange();
    })
  }
  variantChange() {
    this.selectedVariantId = this.querySelector('[name="id"]').value;
    const variantUrl = `/products/${this.dataset.productHandle}?view=card&variant=${this.selectedVariantId}&section=${this.sectionId}&showSubscription=${this.showsubs}`;

    //Change the DOM Elements
    fetch(variantUrl)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const responseCard = html.querySelector('marmeto-product-card');
        this.innerHTML = responseCard.innerHTML;
        this.querySelector('marmeto-product-card .option-button_product').classList.add('selected');
      }).finally(()=>{
        if(typeof(updateProductCards)==='function'){
          updateProductCards();
        }
      });
  }
}
customElements.define('marmeto-product-card', MarmetoProductCard)

class MMvariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateVariantInput();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#mm-product-form--${this.dataset.pid}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${index}`] === previousOptionSelected).map(variantOption => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`mm-product-form--${this.dataset.pid}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`mm-product-form--${this.dataset.pid}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.pid}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('mm-variant-selects', MMvariantSelects);

class MMvariantRadios extends MMvariantSelects {
  constructor() {
    super();

    const fieldsets = document.querySelectorAll('fieldset');
    const showSub = this.closest('.product-card-container').getAttribute('data-show-status');
    if (showSub === 'false') {
      fieldsets.forEach((each) => {

        const button = each.nextElementSibling;

        button.style.display = each.scrollHeight > 24 ? 'block' : 'none';
      });
    }


    document.addEventListener('DOMContentLoaded', () => {
      if (showSub === 'false') {
        document.querySelectorAll('input').forEach((each) => {
          if (each.checked) {
            const checkedElId = each.getAttribute('id');
            const labelForCheckedEl = document.querySelector(`[for="${checkedElId}"]`);
            if (labelForCheckedEl) {
              each.style.order = -10;
              labelForCheckedEl.style.order = -10;
            }
          }
        });
      }
    });



    const showEls = this.querySelectorAll('.show-more-options');


    showEls.forEach((showEl, index) => {
      showEl.addEventListener('click', (event) => {

        event.preventDefault();
        const fieldsetEl = showEl.closest('.fieldset-container').querySelector('fieldset');
        fieldsetEl.classList.toggle('fieldset-element');
        showEl.classList.toggle('expand-button')
        if (!fieldsetEl.classList.contains('fieldset-element')) {
          this.closest('.product-card-container').setAttribute('option' + index, index);
        } else {
          if (pCContainerEl.hasAttribute('option' + index)) {
            pCContainerEl.removeAttribute('option' + index);
          }
        }

      });

    });

    const pCContainerEl = this.closest('.product-card-container');
    const optionValues = [pCContainerEl.getAttribute('option0'), pCContainerEl.getAttribute('option1'), pCContainerEl.getAttribute('option2')];
    if (showSub === 'false') {
      for (let i = 0; i < optionValues.length; i++) {
        if (optionValues[i] !== null && optionValues[i] === '0') {
          const fieldset = this.querySelectorAll('fieldset')[i];
          if (fieldset) {
            fieldset.classList.remove('fieldset-element');
          }
        }
      }
    }


  }





  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}



customElements.define('mm-variant-radios', MMvariantRadios);

customElements.define('mm-product-form', class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.form.querySelector('[name=id]').disabled = false;
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    this.submitButton = this.querySelector('[type="submit"]');
    if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
  }

  async onSubmitHandler(evt) {
    evt.preventDefault();
    if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

    this.handleErrorMessage();

    this.submitButton.setAttribute('aria-disabled', true);
    this.submitButton.classList.add('loading');
    this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));

    const formData = new FormData(this.form);
    if (this.cart) {
      formData.append('sections', sectionsToBundle.join(","));
      formData.append('sections_url', window.location.pathname);
    }
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);

          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (!soldOutMessage) return;
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.querySelector('span').classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          this.error = true;
          return;
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }
        this.error = false;
        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener('modalClosed', () => {
            setTimeout(() => { this.cart.renderContents(response) });
          }, { once: true });
          quickAddModal.hide(true);
        } else {
          this.updateCart(response)
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.submitButton.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
      });
  }

  async updateCart(responseJson) {
    const cartContent = await fetch(`${Shopify.routes.root}cart.js`).then((res) => res.json()).then((data) => { return data });
    cartContent["sections"] = responseJson["sections"];
    this.dispatchEvent(new CustomEvent("variant:add", {
      bubbles: true,
      detail: {
        items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson],
        cart: cartContent
      }
    }));
    document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
      bubbles: true,
      detail: {
        baseEvent: "variant:add",
        cart: cartContent
      }
    }));
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    if (!this.errorMessageWrapper) return;
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }
});



class ProductSubs extends HTMLElement {
  constructor() {
    super();
    this.productId = this.dataset.pid;
    this.getProductSubscriptions(this.productId);
    this.querySelector('#cart-button').addEventListener('click', this.addToCart.bind(this))
  }

  async getProductSubscriptions(productId) {
    //recurpay api , making post request with product id
    const url = 'https://plushforher.recurpay.com/api/storefront/v2/plans';

    const requestOptions = {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        products: [productId]
      }),
    };

    fetch(url, requestOptions)
      .then(response => response.json())
      .then(data => {
        //dynamically add the data form recurpay and show subscription options
        const subscribeOptionsWrapper = this.querySelector('.subscription-options-wrapper');
        subscribeOptionsWrapper.innerHTML = '';
        const subscriptionPlanEle = document.createElement('div');
        subscriptionPlanEle.classList.add('subscription-plan-container');
        subscribeOptionsWrapper.appendChild(subscriptionPlanEle);

        data.plans[0].product.plans.forEach((plan, index) => {
          const labelContainerEle = document.createElement('label');
          labelContainerEle.setAttribute('data-value', plan.name)
          labelContainerEle.setAttribute('data-plan-id', plan.id);
          labelContainerEle.classList.add('subscription-options');
          subscriptionPlanEle.appendChild(labelContainerEle);

          const planElement = document.createElement('input');
          planElement.type = 'radio';
          planElement.name = 'subscription_plan';
          planElement.value = plan.name; // Set the value of the radio button
          const storageEl = document.querySelector('subscribe-product').dataset.subscribedLabel
          if ((storageEl === '' && index === 0) || storageEl === plan.name) {
            planElement.checked = true;
            labelContainerEle.classList.add('selected-plan')
          }
          labelContainerEle.appendChild(planElement);

          const planLabel = document.createElement('span'); // Add a span for label text
          planLabel.textContent = plan.name;



          labelContainerEle.appendChild(planLabel);

          const discountEle = document.createElement('span');
          const discountPrice = data.plans[0].product.plans[index].pricing_policy[0].discount.value;
          discountEle.textContent = discountPrice + '% OFF';
          discountEle.classList.add('discount-value');
          discountEle.setAttribute('data-variant-discount', discountPrice);
          labelContainerEle.appendChild(discountEle);
        });

        this.querySelectorAll('[type="radio"]').forEach((radioEl) => {
          if (radioEl.checked) {
            this.discountedPrice(radioEl.closest('label'));
          }
        });

        //selected subscription options will be updated and also add passes the selected elemet to discountPrice function
        const subscriptionOptions = this.querySelectorAll('.subscription-options');
        subscriptionOptions.forEach((option) => {
          option.addEventListener('change', () => {
            subscriptionOptions.forEach((Element) => Element.classList.remove('selected-plan'))
            option.classList.add('selected-plan');
            option.closest('subscribe-product').dataset.subscribedLabel = option.dataset.value
            this.discountedPrice(option)
          });
        });
      });

  }


  discountedPrice(option) { //onchange of options the price will be updated based on subscription discount
    const discountPercent = option.querySelector('.discount-value').dataset.variantDiscount
    const variantPrice = parseFloat(this.dataset.variantPrice) / 100;
    const discount = (discountPercent / 100) * variantPrice;
    const priceAfterDiscount = variantPrice - discount;
    this.querySelector('.price').textContent = 'Rs. ' + priceAfterDiscount
    this.subDataEle = option;
  }

  addToCart() { //subscribed product added to cart with additional properties required for recurpay checkout

    let formData = {
      id: this.dataset.vid,
      quantity: 1,
      properties: {
        Subscription: this.subDataEle.dataset.value,
        _PlanId: this.subDataEle.dataset.planId,
      },
    };

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((response) => {
        const closeEle = this.closest('.subscribe-product-container').querySelector('.icon-close')
        document.querySelector('subscribe-product').removePopup(closeEle);

        this.refreshCart()
      })
      .catch((error) => {
        console.error("Error:", error);
        // Handle the error here if needed
      });
  };

  refreshCart() { //when subscribed product add to cart making fetch call to cart-drawer and replaces with updated data

    fetch('/cart?section_id=cart-drawer')
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        document.querySelector('cart-drawer').show();  //opens the cart drawer
        const cartDrawer = document.querySelector('cart-drawer')
        cartDrawer.innerHTML = html.querySelector('.cart-drawer').innerHTML;
        cartDrawer.classList.remove('drawer--center-body');

      })
      .catch(e => {
        console.error(e);
      });
  }

}

customElements.define('product-subs', ProductSubs);

// // SHow Product images based on Selected Variants 
// const pdpVariants = document.querySelectorAll('.variant-picker__option-values input')
// pdpVariants.forEach((eachVariant) => {
//   eachVariant.addEventListener('click', () => {
//     console.log(eachVariant)
//     console.log("PDP Variant Clicked")
//   })
// })